// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-menu-link.czt-menu-link{display:flex;height:100%;align-items:center;color:#163f6e !important;padding:0 15px;font-size:1rem}.czt-menu-link.czt-menu-link:hover{text-decoration:none !important;color:#ff0018 !important}.czt-menu-link.czt-menu-link.active{border-top:4px solid transparent;border-bottom:4px solid #ff0018}", ""]);
// Exports
module.exports = exports;
